import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBez7GvNH0lJpP3U9-EB2vus6YC5Dy4PFQ",
  authDomain: "seniorvaultcapital.firebaseapp.com",
  projectId: "seniorvaultcapital",
  storageBucket: "seniorvaultcapital.firebasestorage.app",
  messagingSenderId: "861493974470",
  appId: "1:861493974470:web:a45ba28cbcfc7948640ec7",
  measurementId: "G-YNSB1KQK6R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const storage = getStorage(app)
export const db = getFirestore(app)
